export default __webpack_public_path__ + "static/media/bringFront-white.f867dedb.png";